import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const LoginPage = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/auth/login`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email, password }),
        }
      );

      const data = await response.json();

      if (response.ok) {
        if (rememberMe) {
          localStorage.setItem("authToken", data.token); // or any identifier
        } else {
          sessionStorage.setItem("authToken", data.token);
        }
        // Optional: save token or user data
        navigate("/HomePage");
      } else {
        setError(data.message || "Login failed");
      }
    } catch (err) {
      setError("An error occurred. Please try again.");
      console.error(err);
    }
  };

  return (
    <div className="welcome_page">
      <div className="sidebar">
        <img
          src="sidebar_avatar.png"
          alt="Sidebar Avatar"
          className="sidebar_avatar"
        />
        <img
          src="church_logo_no_bg.png"
          alt="Church Logo"
          className="church_logo"
        />
      </div>
      <div className="media_query_banner_container">
        <div className="media_query_banner">
          <img src="banner_md.png" alt="Media Query Banner" />
          <img
            src="church_logo_no_bg.png"
            alt="Church Avatar No BG"
            className="media_query_logo"
          />
        </div>
        <div className="cross_icon">
          <img src="cross_icon.png" alt="Church Cross Icon" />
        </div>
      </div>

      <div className="form_side">
        <div className="form_main">
          <div className="form_head">
            <h1>Welcome</h1>
            <p>Login to your Dashboard</p>
          </div>

          <div className="form_body">
            <form onSubmit={handleLogin}>
              <div className="form_body1">
                <label htmlFor="email">EMAIL ADDRESS</label>
                <input
                  type="email"
                  placeholder="johndoe@example.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>

              <div className="form_body1 form_pass">
                <label htmlFor="password">PASSWORD</label>
                <input
                  type={showPassword ? "text" : "password"}
                  placeholder="************"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
                <button
                  type="button"
                  className="form_toggle_btn"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? "🙈" : "👁️"}
                </button>
              </div>

              <div className="form_bottom">
                <label>
                  <input
                    type="checkbox"
                    className="form_bottom_input"
                    checked={rememberMe}
                    onChange={() => setRememberMe(!rememberMe)} // ✅ Connect to state
                  />
                  Remember Me
                </label>
                <span
                  style={{
                    cursor: "pointer",
                    color: "#007bff",
                    fontSize: "small",
                  }}
                  onClick={() => navigate("/PasswordPage")}
                >
                  Forgot Password?
                </span>
              </div>

              {error && (
                <p style={{ color: "red", fontSize: "small" }}>{error}</p>
              )}

              <button className="form_login_btn" type="submit">
                LOGIN
              </button>
              <p
                style={{
                  marginTop: "1rem",
                  fontSize: "small",
                  textAlign: "center",
                }}
              >
                Don’t have an account?{" "}
                <span
                  style={{
                    textDecoration: "underline",
                    cursor: "pointer",
                    color: "#007bff",
                    fontSize: "small",
                  }}
                  onClick={() => navigate("/AccountPage")}
                >
                  Create one
                </span>
              </p>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
